// TestimonialSlider.js
import React, { useState, useEffect } from "react";
import testimonials from "../globals/data";
import "../styles/testimonials.css";

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Automatically move to the next slide every 5 seconds
  useEffect(() => {
    if (!isPaused) {
      const timer = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
      }, 3000);

      return () => clearInterval(timer); // Cleanup the timer on component unmount
    }
  }, [isPaused]);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div
      className="slider-container"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <h2 className="slider-title">What People Say About Us</h2>
      <div className="after-line-testimonail"></div>
      <div className="slider-content">
        <button className="slider-button-testimonial prev" onClick={handlePrevious}>
          &#10094;
        </button>
        <div className="testimonial">
          <img
            src={testimonials[currentIndex].image}
            alt={`${testimonials[currentIndex].name}`}
            className="testimonial-image"
          />
          <h3 className="testimonial-name">{testimonials[currentIndex].name}</h3>
          <p className="testimonial-role">{testimonials[currentIndex].role}</p>
          <p className="testimonial-message">
            "{testimonials[currentIndex].message}"
          </p>
        </div>
        <button className="slider-button-testimonial next" onClick={handleNext}>
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default TestimonialSlider;
